module.exports = __webpack_public_path__ + "img/tlb.1cf9df63.png";